import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "../actions/api"; 

export const fetchAppointmentTypes = createAsyncThunk(
  'appointmentTypes/fetchAppointmentTypes',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get('/clinic/dashboard/appointments');
      return res.data.data; 
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch appointment types');
    }
  }
);

const initialState = {
  typeOfAppointment: {},
  enhancedAppointmentTypeMix:{},
  reschedulingRate: [],
  patientWaitTime: {},
  enhancedTimeSlotHeatmap:{},
  appointmentFunnel:{},
  facilityUtilization:{},
  enhancedNoShowRescheduleRate:{},
  loading: false,
  error: null,
};

const appointmentTypeSlice = createSlice({
  name: 'appointmentTypes',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointmentTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppointmentTypes.fulfilled, (state, action) => {
        state.loading = false;

        state.typeOfAppointment = action.payload.typeOfAppointment || {};
        state.enhancedAppointmentTypeMix = action.payload.enhancedAppointmentTypeMix || {};
        state.reschedulingRate = action.payload.reschedulingRate || [];
        state.patientWaitTime = action.payload.patientWaitTime || {};
        state.enhancedTimeSlotHeatmap = action.payload.enhancedTimeSlotHeatmap || {};
        state.appointmentFunnel = action.payload.appointmentFunnel || {};
        state.facilityUtilization = action.payload.facilityUtilization || {};
        state.enhancedNoShowRescheduleRate = action.payload.enhancedNoShowRescheduleRate || {};
      })
      .addCase(fetchAppointmentTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default appointmentTypeSlice.reducer;